import './index.scss'
import '../base.css'

import { Toast } from 'vant'

/**
 * 加载中弹窗
 * @param message 提示内容
 * @param duration 延迟关闭时间
 * @returns 关闭函数
 */
export default function LoadingToast (message = '', duration = 0) {
  const toast = Toast.loading({
    duration,
    message,
    className: 'loading-toast',
    icon: require('@/assets/images/loading.gif'),
  })

  return toast.clear as () => void
}
